import { createContext } from 'react';
import { CatalogUseCases } from '../../main/factories/catalog-dependencies.factory';

export const CatalogContext = createContext<CatalogUseCases | undefined>(undefined);
